import { Link } from 'react-router-dom';
import { rankingMovies } from '@/mocks/movies';

export default function RankingSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
              排行榜
            </h2>
            <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100">
              <div className="w-3.5 h-3.5 flex items-center justify-center text-secondary-600">
                <i className="ri-fire-line text-sm"></i>
              </div>
              <span className="text-xs font-medium text-secondary-700">本周热度</span>
            </div>
          </div>
          <span className="text-sm text-foreground-500">实时更新</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200">
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4 flex items-center gap-2">
              <div className="w-6 h-6 flex items-center justify-center rounded-md bg-primary-500">
                <i className="ri-movie-line text-sm text-background-50"></i>
              </div>
              电影排行 TOP4
            </h3>
            <div className="space-y-3">
              {rankingMovies.filter(m => m.category === '电影').slice(0, 4).map((movie, index) => (
                <Link
                  key={movie.id}
                  to={`/article/${movie.id}`}
                  className="flex items-center gap-3 p-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group"
                >
                  <div className={`w-7 h-7 flex items-center justify-center rounded-lg font-heading text-sm font-bold flex-shrink-0 ${
                    index === 0 ? 'bg-primary-500 text-background-50' :
                    index === 1 ? 'bg-primary-300 text-background-50' :
                    index === 2 ? 'bg-secondary-300 text-background-50' :
                    'bg-background-200 text-foreground-500'
                  }`}>
                    {index + 1}
                  </div>
                  <div className="w-16 h-10 rounded-lg overflow-hidden flex-shrink-0">
                    <img src={movie.image} alt={movie.title} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {movie.title}
                    </h4>
                    <p className="text-xs text-foreground-400 mt-0.5">{movie.rating}分 · {(movie.views / 10000).toFixed(0)}万播放</p>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0">
                    <i className="ri-play-circle-line text-xl"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200">
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4 flex items-center gap-2">
              <div className="w-6 h-6 flex items-center justify-center rounded-md bg-accent-500">
                <i className="ri-tv-line text-sm text-background-50"></i>
              </div>
              剧集/综艺 TOP4
            </h3>
            <div className="space-y-3">
              {rankingMovies.filter(m => m.category !== '电影').slice(0, 4).map((movie, index) => (
                <Link
                  key={movie.id}
                  to={`/article/${movie.id}`}
                  className="flex items-center gap-3 p-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group"
                >
                  <div className={`w-7 h-7 flex items-center justify-center rounded-lg font-heading text-sm font-bold flex-shrink-0 ${
                    index === 0 ? 'bg-accent-500 text-background-50' :
                    index === 1 ? 'bg-accent-300 text-background-50' :
                    index === 2 ? 'bg-secondary-300 text-background-50' :
                    'bg-background-200 text-foreground-500'
                  }`}>
                    {index + 1}
                  </div>
                  <div className="w-16 h-10 rounded-lg overflow-hidden flex-shrink-0">
                    <img src={movie.image} alt={movie.title} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-medium text-foreground-900 group-hover:text-accent-600 transition-colors truncate">
                      {movie.title}
                    </h4>
                    <p className="text-xs text-foreground-400 mt-0.5">{movie.rating}分 · {(movie.views / 10000).toFixed(0)}万播放</p>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center text-foreground-300 group-hover:text-accent-500 transition-colors flex-shrink-0">
                    <i className="ri-play-circle-line text-xl"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}